module.exports = __webpack_public_path__ + "static/media/XL.a2edaaa3.jpg";